import {FC} from 'react';
import {EmptyView} from './StyledEmptyTableView'

const EmptyTableView:FC = () => <EmptyView>No Records Found</EmptyView>;

export default EmptyTableView;